// Use of this namespace should be restricted only to telemetry concepts that would confuse otherwise readable code
// Members of this namespace should *never* be used for business logic or functionality
// Each item in this namespace should be well commented
export var Data;
(function (Data) {
    class Telemetry {
        constructor() {
            this._visibility = 0 /* Unknown */;
            this._percentVisible = "Unknown";
        }
        get visibility() {
            return this._visibility;
        }
        set visibility(state) {
            this._visibility = state;
        }
        get percentVisible() {
            return this._percentVisible;
        }
        set percentVisible(state) {
            this._percentVisible = state;
        }
    }
    Data.Telemetry = Telemetry;
})(Data || (Data = {}));
